(function ($) {
    var self = {
        actions: {
            initAddVoucherClick: function () {
                $("[data-action='add-voucher']").click(function () {
                    var $this = $(this);
                    var input = $($this.data("voucher-input"));
                    var price = $this.data("price");
                    var voucherTypeId = $this.data("id");

                    if (input.length > 0) {
                        var vouchersQuantity = self.getVouchersCount(input.val());
                        input.val(++vouchersQuantity);

                        self.price.updateCurrentBlock(voucherTypeId);
                        self.price.calculateTotal();
                    }
                });
            },
            initTakeVoucherAwayClick: function () {
                $("[data-action='take-voucher-away']").click(function () {
                    var $this = $(this);
                    var input = $($this.data("voucher-input"));
                    var voucherTypeId = $this.data("id");

                    if (input.length > 0) {
                        var vouchersQuantity = self.getVouchersCount(input.val());
                        vouchersQuantity--;

                        if (vouchersQuantity < 0) {
                            vouchersQuantity = 0;
                        }

                        input.val(vouchersQuantity);

                        self.price.updateCurrentBlock(voucherTypeId);
                        self.price.calculateTotal();
                    }
                });
            },
            initPrintClick: function () {
                $('.voucher-print').bind('change', function () {
                    self.print.run();
                });

                $(".delivery-type").bind('change', function () {
                    self.price.calculateTotal();
                });
            },
            init: function () {
                self.actions.initAddVoucherClick();
                self.actions.initTakeVoucherAwayClick();
                self.actions.initPrintClick();
            }
        },
        print: {
            run: function () {
                self.delivery.shipping();
                self.price.calculateTotal();

                if ($("#voucher-print").is(":checked")) {
                    self.delivery.addValidation();
                } else {
                    self.delivery.removeValidation();
                }
            }
        },
        price: {
            updateCurrentBlock: function (voucherTypeId) {
                var voucherListRow = $("#vouchers-list div[data-voucher-type='" + voucherTypeId + "']");
                var voucherValueElem = voucherListRow.find(".voucher-value");
                var voucherTypeQuantity = voucherValueElem.val();
                var price = voucherValueElem.data('price');

                if (voucherTypeQuantity > 0) {
                    voucherListRow.addClass("selected");
                    voucherListRow.find(".vouchers-quantity").html(voucherTypeQuantity);
                    voucherListRow.find(".total-voucher-price").text(voucherTypeQuantity * price + " zł");
                    voucherListRow.find(".ticket-empty").remove();
                    voucherListRow.find(".table-vouchers__minus").attr('disabled', false);
                } else {
                    voucherListRow.removeClass("selected");
                    voucherListRow.find(".vouchers-quantity").text("0");
                    voucherListRow.find(".total-voucher-price").text("0 zł");
                    voucherListRow.find(".table-vouchers__minus").attr('disabled', true);
                }
            },
            calculateTotal: function () {
                var totalPrice = 0;
                $('.voucher-value').each(function () {
                    var $this = $(this);

                    var quantity = parseInt($this.val());
                    if (quantity > 0) {
                        var price = parseInt($this.data("price"));
                        price = price * quantity;
                        totalPrice += price;
                    }
                });

                if ($('#voucher-print').is(':checked')) {
                    var selectedDeliveryType = $(".delivery-type:checked");

                    if (selectedDeliveryType.length) {
                        totalPrice += parseFloat(selectedDeliveryType.data('price'));
                    }
                }

                if (totalPrice > 0) {
                    $("#total_price").text(totalPrice + " zł");
                } else {
                    $("#total_price").text("0 zł");
                }
            }
        },
        delivery: {
            addValidation: function () {
                $("#name").rules("add", { required: true, maxlength: 255, minlength: 2 });
                $("#address").rules("add", { required: true, maxlength: 255, minlength: 2 });
                $('#city').rules("add", { required: true, maxlength: 255, minlength: 2 });
                $('#postal_code').rules("add", { required: true, postal_code: true, maxlength: 255, minlength: 2 });
                $("input[name='delivery_type']").rules("add", { required: true });
            },
            removeValidation: function () {
                $("#name").rules("remove");
                $("#address").rules("remove");
                $("#city").rules("remove");
                $("#postal_code").rules("remove");
                $("input[name='delivery_type']").rules("remove");
                $("#voucher-shipping .form-group").each(function () {
                    $(this).removeClass('has-error');
                    $(this).find('.error-message').remove();
                });
            },
            shipping: function () {
                if ($('#voucher-print').is(':checked')) {
                    $("#voucher-shipping").show(500);

                } else {
                    $("#voucher-shipping").hide(500);
                    $('#voucher-shipping').find('input[type="radio"]').each(function () {
                        $(this).removeAttr('checked');
                    });
                }
            }
        },
        validation: {
            validateQuantity: function () {
                var isValid = true;

                if (self.validation.checkQuantity()) {
                    $('#quantity_error_msg').hide();
                } else {
                    isValid = false;
                    $('#quantity_error_msg').show();
                }

                return isValid;
            },
            checkQuantity: function() {
                var totalQuantity = 0;

                $('.voucher-value').each(function () {
                    totalQuantity += parseInt($(this).val());
                });

                return totalQuantity > 0;
            },
            init: function () {
                var e = $("#voucher-order");
                var r = $(".alert-danger", e);
                var i = $(".alert-success", e);

                if (e.length > 0) {
                    e.validate({
                        errorElement: "span",
                        errorClass: "error-message",
                        focusInvalid: !1,
                        ignore: "",
                        rules: {
                            first_name: {
                                minlength: 2,
                                maxlength: 255,
                                required: !0
                            },
                            last_name: {
                                minlength: 2,
                                maxlength: 255,
                                required: !0
                            },
                            tel: {
                                minlength: 2,
                                digits: true,
                                maxlength: 15,
                                required: !0
                            },
                            email: {
                                minlength: 2,
                                maxlength: 255,
                                required: !0,
                                email: true
                            },
                            email_confirm: {
                                minlength: 2,
                                maxlength: 255,
                                required: true,
                                email: true,
                                equalTo: "#email"
                            },
                            personal_data_agreement: {
                                required: true
                            },
                            voucher_regulations_agreement: {
                                required: true
                            },
                            regulations_agreement: {
                                required: true
                            }
                        },
                        invalidHandler: function (form, validator) {
                            i.hide();
                            r.show();

                            $('html, body').animate({
                                scrollTop: $(".personal-data-container").offset().top
                            }, 1000);
                        },
                        errorPlacement: function (error, element) {
                            error.appendTo(element.parent());
                        },
                        highlight: function (e) {
                            $(e).closest(".form-group").removeClass("has-success").addClass("has-error")
                        },
                        unhighlight: function (e) {
                        },
                        success: function (e, r) {
                            var i = $(r).parent(".input-icon").children("i");
                            $(r).closest(".form-group").removeClass("has-error").addClass("has-success");
                            i.removeClass("fa-warning").addClass("fa-check");
                        },
                        submitHandler: function (e) {
                            i.show();
                            r.hide();

                            if (self.validation.validateQuantity() == false) {
                                $('html, body').animate({
                                    scrollTop: $(".event-container").offset().top
                                }, 1000);
                                return false;
                            }

                            e[0].submit();
                        }
                    });
                }
            }
        },
        getVouchersCount: function (inputValue) {
            return $.isNumeric(inputValue)
                ? parseInt(inputValue)
                : 0;
        },
        recoverValues: function () {
            if ($('#voucher-print').is(':checked')) {
                $('#voucher-shipping').show();

                if (country_val != undefined && country_val != '') {
                    $('#country option').filter(function () {
                        return $(this).html() == country_val;
                    }).attr('selected', 'selected');
                } else {
                    $('#country option').filter(function () {
                        return $(this).html() == 'Polska';
                    }).attr('selected', 'selected');
                }

                if (typeof(selectedDeliveryTypeId) !== "undefined") {
                    var selectedDeliveryTypeRadio = $("input[name='delivery_type'][value='" + selectedDeliveryTypeId + "']");

                    if(selectedDeliveryTypeRadio.length > 0) {
                        selectedDeliveryTypeRadio.attr('checked', 'checked');
                    }
                }
            }

            $('.voucher-value').each(function () {
                var $this = $(this);

                quantity = parseInt($this.val());
                self.price.updateCurrentBlock($this.data("id"));
            });

            self.price.calculateTotal();
        },
        init: function () {
            self.actions.init();
            self.validation.init();
            self.recoverValues();
        }
    };

    $(document).ready(function () {
        if(typeof(initVouchers) !== "undefined" && initVouchers) {
            self.init();
        }
    });
})(jQuery);